import React from 'react'
import FaceClick from '@/components/face-click'
import Layout from '../layout'
import styles from './index.module.scss'

import { getContent } from '@/common/modal_content.js'

export default class Index extends React.PureComponent {
  state = {
    faceText: ''
  }

  getFaceDots = () => {
    const { language } = this.props;
    return [
    {
      name: 'dot1',
      text: (
        <div className={styles.linkText}>
            { getContent(language, 'face_modal_dot1_content') }
          </div>
      ),
      left: '65.97%',
      top: '35.9%',
    },
    {
      name: 'dot2',
      text: (
        <div className={styles.linkText}>
            { getContent(language, 'face_modal_dot2_content') }
          </div>
      ),
      left: '60.97%',
      top: '48.9%',
    },
    {
      name: 'dot3',
      text: (
        <div className={styles.linkText}>
        { getContent(language, 'face_modal_dot3_content') }
      </div>
      ),
      top: '46.4%',
      left: '30.05%',
    },
    {
      name: 'dot4',
      text: (
        <div className={styles.linkText}>
            { getContent(language, 'face_modal_dot4_content') }
          </div>
      ),
      left: '36.31%',
      top: '83.21%'
    },
    {
      name: 'dot5',
      text: (
        <div className={styles.linkText}>
            { getContent(language, 'face_modal_dot5_content') }
          </div>
      ),
      left: '35.25%',
      top: '22.25%'
    }]
  }


  render() {

    const { language, mobile } = this.props
    const dots = this.getFaceDots();

    return (
      <>
        <Layout
          title={
            <p>
              { getContent(language, 'face_modal_title') }
            </p>
          }
          titleTips={ getContent(language, 'face_modal_dot1_subtitle') }
          text={this.state.faceText || dots[0].text}
          left={
            <div>
            <div className={styles.leftwrap}>
              <FaceClick
                dots={dots}
                defaultActived={0}
                onClick={(name, dot) => {
                  this.setState({
                    faceText: dot.text,
                  })
                }}
              ></FaceClick>
            </div>
              <div align="center" className={styles.lightText}>
              <img src={ getContent(language, 'modal_click_img') } className={styles.handImg} />
              <p className={styles.guideText}>{ getContent(language, 'face_modal_tip') }</p>
            </div>
          </div>
          }
        />
      </>

    )
  }
}
